import { EditorState, Plugin, Transaction } from 'prosemirror-state'
import templateStore from 'stores/TemplatesStore'

export const TemplatePickerPlugin = new Plugin({
  state: {
    init: (config, state) => {
      return {}
    },
    apply(tr: Transaction, pluginState: any, oldState: EditorState, newState: EditorState) {
      if (tr.getMeta('blockIdFix')) {
        return pluginState
      }

      if (
        tr.getMeta('rebased') === undefined &&
        !tr.getMeta('TEMPLATE_PREVIEW') &&
        tr.steps.length &&
        tr.docChanged &&
        templateStore.isPickerVisible
      ) {
        if (templateStore.selectedPickerTemplate) {
          templateStore.setState({
            trackTemplateUsage: true,
          })
        } else {
          templateStore.closePicker()
        }
      }

      return pluginState
    },
  },
})
